import { GraphiQL } from 'graphiql';
import 'graphiql/graphiql.css';
import React from 'react';
import type { Fetcher } from '@graphiql/toolkit';
import CommandPalette from './CommandPalette';

const GraphiQLEditor: React.FC = () => {
  // Custom fetcher that includes authentication headers
  const fetcher: Fetcher = async (graphQLParams) => {
    const token = localStorage.getItem('access_token');

    console.log(
      '[GraphiQL] Token from localStorage:',
      token ? `${token.substring(0, 20)}...` : 'NO TOKEN',
    );

    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
      console.log(
        '[GraphiQL] Authorization header set:',
        headers['Authorization'].substring(0, 30) + '...',
      );
    } else {
      console.warn('[GraphiQL] No token found in localStorage');
    }

    console.log('[GraphiQL] Request headers:', headers);

    const response = await fetch('/graphql', {
      method: 'POST',
      headers,
      body: JSON.stringify(graphQLParams),
      credentials: 'include',
    });

    console.log('[GraphiQL] Response status:', response.status);

    return response.json();
  };

  return (
    <>
      <div style={{ height: '100vh', width: '100%' }}>
        <GraphiQL fetcher={fetcher} />
      </div>
      <CommandPalette />
    </>
  );
};

export default GraphiQLEditor;
